import { render } from "./FileInput.vue?vue&type=template&id=6835d028"
import script from "./FileInput.vue?vue&type=script&lang=js"
export * from "./FileInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Forms/FileInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6835d028"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6835d028', __exports__)) {
    api.reload('6835d028', __exports__)
  }
  
  module.hot.accept("./FileInput.vue?vue&type=template&id=6835d028", () => {
    api.rerender('6835d028', render)
  })

}


export default __exports__